import React, { useContext } from 'react'
import ComplaintRisk from './ComplaintRisk';
import EmotionalAnalytics from './EmotionalAnalytics';
import QualityAnalysis from './QualityAnalysis';
import Script from './Script';

import { Context } from '../../utils/context';

import "./dashboard.css";

const Dashboard = () => {

    const { dashAction, setDashAction } = useContext(Context);


  return (
    <>
        <div className="dashboard">
            <div className="dashboard-head">
                <ul>
                    <li onClick={()=>setDashAction('complaint')} className={dashAction === 'complaint'? 'current':''}>Complaint Risk Analysis</li>
                    <li onClick={()=>setDashAction('quality')} className={dashAction === 'quality' ? 'current':''}>Quality Analysis</li>
                
                    <li onClick={()=>setDashAction('emotional')} className={dashAction === 'emotional' ? 'current':''}>Emotional Analytics</li>
                </ul>
                <div className="line"></div>
            </div>
            <div className="dashboard-content">
                {dashAction === 'complaint' && <ComplaintRisk />}
                {dashAction === 'quality' && <QualityAnalysis />}
               
                {dashAction === 'emotional' && <EmotionalAnalytics />}
            </div>
        </div>
    </>
  )
}

export default Dashboard